import { useQuery } from "@tanstack/react-query";
import { driversService } from "../services";
import type { GetDriversParams, Vehicle } from "../types";

export function useDrivers(params?: GetDriversParams) {
	return useQuery({
		queryKey: ["drivers", params],
		queryFn: () => driversService.getAllDrivers(params),

		staleTime: 1000 * 60,
	});
}

export function useDriverById(id: number) {
	return useQuery({
		queryKey: ["driver", id],
		queryFn: () => driversService.getDriverById(id),
		enabled: !!id,
		refetchOnWindowFocus: false,
	});
}

export function useDriversWithoutCnh(params?: GetDriversParams) {
	return useQuery({
		queryKey: ["drivers-without-cnh", params],
		queryFn: () => driversService.getDriversWithoutCnh(params),
	});
}

export function useDriversExpired30Days(params?: GetDriversParams) {
	return useQuery({
		queryKey: ["drivers-expired-3days", params],
		queryFn: () => driversService.getDriversExpired30Days(params),
	});
}

export function useDriversExpiredCnh(params?: GetDriversParams) {
	return useQuery({
		queryKey: ["drivers-expired-cnh", params],
		queryFn: () => driversService.getDriversExpiredCnh(params),
	});
}

export function useVehicles(enabled = true) {
	return useQuery<Vehicle[]>({
		queryKey: ["vehicles"],
		queryFn: () => driversService.getAllVehicles(),
		enabled,
	});
}
